import React from 'react';
import { Button } from 'primereact/button';

interface ForbiddenProps {
  onLogout: () => void;
}

const Forbidden: React.FC<ForbiddenProps> = ({ onLogout }) => {
  return (
    <div
      className="flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div className="text-center" style={{ maxWidth: '32rem', padding: '2rem' }}>
        <i
          className="pi pi-lock"
          style={{ fontSize: '4rem', color: '#173A63' }}
        ></i>
        <h1 className="mt-4 mb-2" style={{ color: '#173A63' }}>
          Access Denied
        </h1>
        <p className="text-lg" style={{ color: '#6c757d' }}>
          You do not have permission to access this page.
        </p>
        <p className="text-sm mb-4" style={{ color: '#6c757d' }}>
          If you believe this is a mistake, please contact your administrator.
        </p>
        <Button
          label="Logout"
          icon="pi pi-sign-out"
          onClick={onLogout}
        />
      </div>
    </div>
  );
};

export default Forbidden;
